import React from 'react';
import { useTranslation } from 'react-i18next';
import ApplicationForm from '../../components/ApplicationForm/ApplicationForm';
import useIsMobile from '../../hooks/useIsMobile';
import './Form.css';

const Form = () => {
  const { t, i18n } = useTranslation();
  const isMobile = useIsMobile();

  const handleSubmit = (formData) => {
    console.log('Form submitted:', formData);
  };

  // Mapa de videos por idioma (formulario público)
  const publicVideoIds = {
    de: '9e9OEGOLBHw',
    ar: '87IpFu3gIis',
    bn: 'DtJ7yKys3a4',
    zh: 'psamzwDzPFs',
    es: 'ta3Ar7lcB_k',
    fr: 'CFDiWEs-ntY',
    hi: 'sRqO16DIH20',
    en: 'viwnkWhstRs',
    pt: 'icqVGec3r5g',
    ru: 'ucFiy2T0c7I'
  };

  const currentLang = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
  const publicVideoId = publicVideoIds[currentLang] || publicVideoIds.en;

  return (
    <div className={`form-page ${isMobile ? 'mobile-form-page' : ''}`}>
      <div className={`form-container ${isMobile ? 'mobile-form-container' : ''}`} id="joinForm">
        <h2 className={isMobile ? 'mobile-title' : ''} style={{ marginBottom: '40px' }}>{t('form.title')}</h2>
        <div className="video-container">
          <iframe
            title="Public intro video"
            src={`https://www.youtube.com/embed/${publicVideoId}?rel=0&modestbranding=1&playsinline=1`
            }
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            style={{ width: '100%', height: '100%' }}
          ></iframe>
        </div>
        <ApplicationForm onSubmit={handleSubmit} isMobile={isMobile} />
      </div>
    </div>
  );
};

export default Form; 